import React, { useState } from 'react'

import { ReactComponent as IconEdit } from 'assets/images/icons/edit-3.svg'
import FormDrawer from 'components/__new/common/form-drawer'
import { ViewPayrollConfigRow } from './ViewPayrollConfigRow';

const ViewRemittanceDetails = (props) => {
    const { isOpen, setIsOpen, remittance, loading, handleEditForm } = props;
    const [isOpenEditRemittance, setIsOpenEditRemittance] = useState(false);   
     
    const handleToggleEditModal = () => {
        setIsOpen(false);
        handleEditForm();
    }
    
    return (
        <>
            {/* <EditRemittance
                isOpen={isOpenEditRemittance}
                setIsOpen={setIsOpenEditRemittance}
                remittance={remittance}
            /> */}
            
            <FormDrawer display="center" size="4xl" isOpen={isOpen} setIsOpen={setIsOpen} backdropClickable={false}>
                <div className="p-6">
                    <FormDrawer.Title
                        title="Remittance"
                        // description="Setup a new approval workflow"
                        showCloseButton={true}
                        close={setIsOpen}
                    />
                    <hr className='mt-3'/>

                    <div className="w-full my-7">
                        {
                            !remittance?.is_default && (
                                <div className="my-7 flex items-center justify-end space-x-2 cursor-pointer text-ep-primary-600"
                                    onClick={handleToggleEditModal}
                                >
                                    <IconEdit />
                                    <span className='underline'>Edit Information</span>
                                </div>
                            )
                        }
                        
                        <div className='p-2 rounded-xl border bg-ep-primary-light-300'>
                            <div className='font-medium text-[#374151] text-lg'>Remittance Information</div>
                            <div className='bg-white mt-4 rounded-2xl p-5 shadow-box-shadow'>
                                <div className='flex flex-col gap-6'>
                                    <ViewPayrollConfigRow
                                        leftLabel="Name of Remittance Party"
                                        leftValue={remittance?.name?.replaceAll("_", " ")?.toLowerCase()}
                                        leftValueClassName={remittance?.is_default ? "uppercase" : "capitalize"}
                                        rightLabel="Description"
                                        rightValue={remittance?.description || "-"}
                                    />
                                    <ViewPayrollConfigRow
                                        leftLabel="Bank Name"
                                        leftValue={remittance?.bank_name || "-"}
                                        leftValueClassName="capitalize"
                                        rightLabel="Account Number"
                                        rightValue={remittance?.account_number || "-"}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </FormDrawer>
        
        </>
    )
}



export default ViewRemittanceDetails;